<template>
    <section>

        <table class="table is-fullwidth is-countable is-borderless">
            <thead>
            <tr>
                <th rowspan="2" class="is-narrow"></th>
                <th rowspan="2" style="min-width: 400px">วัตถุประสงค์</th>
                <th rowspan="2">
                    ตัวชี้วัด (KPIs)
                </th>
                <th class="has-text-centered" colspan="5">เป้าหมาย</th>
            </tr>
            <tr>
                <th class="has-text-right">ไตรมาส 1</th>
                <th class="has-text-right">ไตรมาส 2</th>
                <th class="has-text-right">ไตรมาส 3</th>
                <th class="has-text-right">ไตรมาส 4</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(kpiTemplate, index) in project.kpi_templates">
                <td class="is-counter"></td>
                <td>
                    <input type="hidden"
                           :name="'projectKpiTemplate[' + index + '][id]'"
                           v-model="kpiTemplate.id"
                    />
                    <textarea class="textarea"
                              :name="'projectKpiTemplate[' + index + '][title]'"
                              v-model="kpiTemplate.title"
                              rows="5"
                              autofocus
                              v-autosize
                    ></textarea>
                </td>
                <td>
                         <textarea class="textarea"
                                   :name="'projectKpiTemplate[' + index + '][kpi]'"
                                   v-model="kpiTemplate.kpi"
                                   rows="5"
                                   v-autosize
                         ></textarea>
                </td>
                <td>
                    <div class="control">
                        <input type="number"
                               class="input has-text-right"
                               :name="'projectKpiTemplate[' + index + '][target_q1]'"
                               v-model="kpiTemplate.target_q1"
                        />
                    </div>
                </td>
                <td>
                    <div class="control">
                        <input type="number"
                               class="input has-text-right"
                               :name="'projectKpiTemplate[' + index + '][target_q2]'"
                               v-model="kpiTemplate.target_q2"
                        />
                    </div>
                </td>
                <td>
                    <div class="control">
                        <input type="number"
                               class="input has-text-right"
                               :name="'projectKpiTemplate[' + index + '][target_q3]'"
                               v-model="kpiTemplate.target_q3"
                        />
                    </div>
                </td>
                <td>
                    <div class="control">
                        <input type="number"
                               class="input has-text-right"
                               :name="'projectKpiTemplate[' + index + '][target_q4]'"
                               v-model="kpiTemplate.target_q4"
                        />
                    </div>
                </td>
                <td>
                    <div class="delete"
                         @click.prevent="deleteKpiTemplate(index)"
                    ></div>
                </td>

            </tr>
            </tbody>
        </table>
        <div class="field">
            <button type="button" class="button is-300"
                    @click.prevent="addKpiTemplate"
            >
                <span class="icon"><i class="fa fa-plus"></i></span> &nbsp;
                เพิ่มวัตถุประสงค์
            </button>
        </div>
    </section>
</template>
<script type="text/babel">
    export default {
        data() {
            return {
                newKpiTemplate
            }
        },
        props: {
            project: {type: Object, required: true},
        },
        mounted() {
            if (this.project.kpi_templates.length === 0) {
                this.addKpiTemplate();
            }
        },
        methods: {
            addKpiTemplate() {
                this.project.kpi_templates.push(_.extend({}, this.newKpiTemplate))
            },

            deleteKpiTemplate(index) {
                this.project.kpi_templates.splice(index, 1);
            },
        }
    }
</script>